(() => {
  if (window.FrostskinShortColor) return;
  const originals = new WeakMap();
  function update(picker) {
    const root = picker.closest('product-info') || picker.closest('.shopify-section');
    if (!root) return;
    const black = picker.querySelector('input:checked')?.value === 'Black';
    root.querySelectorAll('[data-fs-black-preview]').forEach((figure) => {
      const img = figure.querySelector('img');
      if (!img) return;
      if (!originals.has(img)) {
        originals.set(img, Object.fromEntries(['src', 'srcset', 'sizes', 'alt', 'width', 'height'].map((key) => [key, img.getAttribute(key)])));
      }
      if (black) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = figure.dataset.fsBlackPreview;
        img.alt = 'Black short-sleeve — digitally edited color preview';
      } else {
        Object.entries(originals.get(img)).forEach(([key, value]) => value === null ? img.removeAttribute(key) : img.setAttribute(key, value));
      }
      figure.querySelectorAll('[data-fs-black-caption]').forEach((caption) => { caption.hidden = !black; });
      figure.querySelectorAll('[data-fs-white-caption]').forEach((caption) => { caption.hidden = black; });
    });
    root.querySelectorAll('[data-fs-white-only]').forEach((figure) => { figure.hidden = black; });
  }
  function init() { document.querySelectorAll('[data-fs-short-color]').forEach(update); }
  document.addEventListener('change', (event) => {
    const picker = event.target.closest('[data-fs-short-color]');
    if (picker) update(picker);
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.FrostskinShortColor = { init };
})();
